module.exports = __webpack_public_path__ + "static/media/collabdot_footer.11f35b40.png";